import * as types from './types'
import premiumApi from '../api'

export const actions = {
    async [types.PREMIUM_FETCH]({commit}, data = null) {
        commit(types.PREMIUM_SET_LOADING, true)
        const response = await premiumApi.all(data)
        commit(types.PREMIUM_OBTAIN, response.data.data)
        commit(types.PREMIUM_META, response.data.meta)
        commit(types.PREMIUM_SET_LOADING, false)
    },
}
